<template>
    <div v-if="this.loggedin === true">
    <ContractWizard :username="username" />
    </div>
    <div v-else>
        You need to log in
        <v-btn @click="loginRedirect">Log In</v-btn>
    </div>
</template>
<script>
import ContractWizard from './ContractWizard'
import axios from 'axios'

export default {
    components: {
        ContractWizard
    },
    data: () => {
        return {
            loggedin: true,
            username: null
        }
    },

    mounted() {
        // axios.get('https://neptune.adelphi.edu/~finkelstein/contract-wiz-auth/')
        //     .then(response => {
        //         const json = response.data
        //         if (json['msg'] == 'authenticated') {
        //             this.loggedin = true
        //             this.username = json['username']
        //         }
        //     })
    },

    methods: {
        loginRedirect() {
            window.location = 'https://neptune.adelphi.edu/~finkelstein/contract-wizard/contract-wiz-auth/contract-redirect.php'
        }
    }

}
</script>